<template>
  <Modal
    :id="'cmp-label-status-form'"
    @cancelled="onCancelClick"
    :loadingFlag="isEditLoading"
  >
    <template slot="header"
      >{{ isEdit ? $t("edit") : $t("add") }} {{ $t("status") }}
    </template>
    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'statusName'"
          v-bind="textFieldConfig"
          v-model="statusName"
          isModel
          :placeholder="$t('status_name')"
          required
          showValidationIcons
          @validated="onValidation"
        />
        <Dropdown
          :id="'external_table'"
          class="m2"
          :options="labelStatusSections"
          :selected="labelStatusSections.find((e) => e.value == external_table)"
          :placeholder="$t('section')"
          box
          @selectedChange="(e) => onLabelSectionChange(e)"
          required
          showValidationIcons
          immediateValidation
          @validated="(e) => onValidation('external_table', e)"
        ></Dropdown>
        <v-layout row wrap justify-start class="checkbox-row">
          <div class="checkbox-control ut-colcen">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'default_status_flag'"
                :id="'default_status_flag'"
                :checked="default_status_flag"
                @click="(e) => onCheckboxChange('default_status_flag', e)"
              />
              <div class="checkmark"></div>
            </div>
          </div>
          <div class="checkbox-text">
            {{ $t("default_for_section") }}
          </div>
        </v-layout>
        <v-layout row wrap justify-start class="checkbox-row">
          <div class="checkbox-control ut-colcen">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'inactive_flag'"
                :id="'inactive_flag'"
                :checked="inactive_flag"
                @click="(e) => onCheckboxChange('inactive_flag', e)"
              />
              <div class="checkmark"></div>
            </div>
          </div>
          <div class="checkbox-text">
            {{ $t("inactive") }}
          </div>
        </v-layout>
      </div>
      <Sketch :value="`#${statusColor.hex}`" @input="onColorChange" />
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
        :class="{ disabled: !isFormValid }"
        @click="onOKClick"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { Sketch } from "vue-color";
import { LabelSettingsService } from "../../services/label-settings.service";
import { createTV } from "../../../../models/text-value.model";

export default {
  components: {
    Modal,
    Sketch,
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        showEditIconOnHover: false,
        box: true,
        immediateValidation: true,
        showValidationIcons: true,
      },
      statusName: "",
      statusColor: { hex: "000000" },
      labelStatusDetails: null,
      labelStatusSections: [],

      default_status_flag: null,
      inactive_flag: null,
      external_table: null,

      validationResult: {},
    };
  },
  mounted: async function () {
    if (this.isEdit) {
      const labelStatusDetails = await LabelSettingsService.findLabelStatusDetails({
        label_status_id: this.label_status_id,
      });
      this.labelStatusDetails = labelStatusDetails?.data?.label_status;
      this.statusName = this.labelStatusDetails.label_status_name;
      this.statusColor = {
        hex: this.labelStatusDetails.label_status_colour,
      };
      this.labelStatusSections = createTV(
        labelStatusDetails?.data?.label_status_sections,
        "textkey",
        "value"
      ).map((e) => {
        return {
          text: this.$t(e.text),
          value: e.value,
        };
      });
      this.default_status_flag = this.labelStatusDetails.default_status_flag ? true : false;
      this.inactive_flag = this.labelStatusDetails.inactive_flag ? true : false;
      this.external_table = this.labelStatusDetails.external_table;
    } else {
      const addLabelStatusInfo = await LabelSettingsService.findLabelStatusDetails({
        label_status_id: "",
      });
      this.labelStatusSections = createTV(
        addLabelStatusInfo?.data?.label_status_sections,
        "textkey",
        "value"
      ).map((e) => {
        return {
          text: this.$t(e.text),
          value: e.value,
        };
      });
    }
  },
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
    isEdit: function () {
      return this.$route.query.modal == "edit_status";
    },
    isEditLoading: function () {
      return this.isEdit ? !this.labelStatusDetails : false;
    },
    isAdd: function () {
      return this.$route.query.modal == "add_status";
    },
    label_status_id: function () {
      return this.$route.query.label_status_id;
    },
    labelStatus: function () {
      return {
        label_status_name: this.statusName,
        label_status_colour: this.statusColor.hex,
        label_status_id: this.label_status_id ? this.label_status_id : "",
        default_status_flag: this.default_status_flag ? 1 : 0,
        inactive_flag: this.inactive_flag ? 1 : 0,
        external_table: this.external_table,
      };
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    onOKClick: function () {
      if (this.isEdit) {
        this.$emit("edited", this.labelStatus);
      } else {
        this.$emit("added", this.labelStatus);
      }
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onColorChange: function (value) {
      this.statusColor = { hex: value.hex.slice(1) };
    },
    onCheckboxChange: function (name, event) {
      this[name] = event.target.checked;
    },
    onLabelSectionChange({ text, value }) {
      this.external_table = value;
    },
    onValidation(name, value) {
      this.$set(this.validationResult, name, value);
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-label-status-form {
  .vc-sketch {
    box-shadow: none;
    width: 100%;
    margin: 5px 0px 5px -10px;
  }

  .checkbox-row {
    margin: 5px;
    .checkbox-control {
    }
    .checkbox-text {
      flex: 1;
      margin-left: 10px;
    }
  }
}
</style>
